import React, { Component } from 'react';

class ErrorBounty extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    }
  }

  componentDidCatch(error) {
    this.serState({hasError:true})
  }

  render() {
    if (this.state.hasError) {
      return <h1>Oooops. That is not good </h1>
    }
    return this.props.children
  }
}

export default ErrorBounty;